import React from 'react';
import { Link } from 'gatsby';
import { isMadPawsStore } from '../../../common/util';

const GatsbyLink = props => {
  const { url, children, activeLink } = props;

  return (
    <Link
      style={{
        color: isMadPawsStore() ? 'var(--primary-default)' : 'initial'
      }}
      activeClassName={activeLink ?? ''}
      to={url || ''}
      {...props}
      data-gatsby-link="true"
    >
      {children}
    </Link>
  );
};

export default GatsbyLink;
